import React from 'react';
import { Star } from 'lucide-react';

const DataTable = ({
  columns,
  rows,
  isDark = false,
  emptyMessage = 'No data',
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className={`border-b ${isDark ? 'border-[#1e2d52]' : 'border-slate-200'}`}>
            {columns.map((col) => (
              <th
                key={col.key}
                className="text-left text-xs font-semibold uppercase tracking-wider pb-3 pr-4"
                style={{ color: isDark ? '#64748b' : '#374151' }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="py-8 text-center text-sm" style={{ color: isDark ? '#64748b' : '#94a3b8' }}>
                {emptyMessage}
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr
                key={row.id || idx}
                className={`border-b last:border-b-0 transition-colors ${
                  isDark
                    ? 'border-[#1e2d52] hover:bg-white/5'
                    : 'border-slate-100 hover:bg-slate-50'
                }`}
              >
                {columns.map((col) => (
                  <td
                    key={col.key}
                    className="py-3 pr-4"
                    style={{ color: isDark ? '#c9d1d9' : '#111827' }}
                  >
                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

// Star rating renderer helper (exportable)
export const RatingCell = ({ rating, isDark }) => (
  <div className="flex items-center gap-1">
    {[1, 2, 3, 4, 5].map((s) => (
      <Star
        key={s}
        className={`w-3 h-3 ${s <= rating ? 'fill-[#F87217] text-[#F87217]' : isDark ? 'text-slate-600' : 'text-slate-200'}`}
      />
    ))}
    <span className="ml-1 text-xs font-medium" style={{ color: isDark ? '#c9d1d9' : '#374151' }}>{rating}</span>
  </div>
);

export default DataTable;